$(() => {
  if (!$('body').hasClass('account-payments')) {
    return;
  }
  const setUpPaymentMethodSelectionTable = function() {
    $('.js-method-specific').addClass('disabled');
    $('.js-method-specific').on('click', function() {
      const $this = $(this);
      const $radio = $this.closest('.js-nested-selection-wdiget').find('.js-method-select');
      if ($this.length > 0) {
        $radio.prop('checked', true);
      }
      $radio.trigger('change');
    });
    $('.js-method-select').on('change', () => {
      $('.js-method-select').each(function(i, radio) {
        const $radio = $(this);
        const $select = $radio.closest('.js-nested-selection-widget').find('.js-method-specific');
        const $submit = $('.js-withdrawal-submit');
        if ($radio.prop('checked')) {
          const needs_w9 =
            $radio.attr('id') === 'check-select' && $radio.attr('data-w9-submitted') === 'false';
          const $w9_warning = $('#w9-warning');

          $select.removeClass('disabled');
          $submit.val(`Withdraw via ${$radio.val()}`);
          if (needs_w9) {
            $submit.addClass('disabled');
            $w9_warning.show();
          } else {
            $submit.removeClass('disabled');
            $w9_warning.hide();
          }
        } else {
          $select.addClass('disabled');
        }
      });
    });
    $('.js-method-select').trigger('change');
  };
  // Make this available inside autopay.js
  Rover.setUpPaymentMethodSelectionTable = setUpPaymentMethodSelectionTable;

  const displayActiveFlatNav = function(id) {
    $('.js-payments-table').hide();
    $(id).show();
  };

  const displayHashedView = function(defaultHash) {
    const hash = window.location.hash || defaultHash;
    if (hash) {
      $(`a[href="${hash}"]`).trigger('click');
    }
  };

  const addBindings = function() {
    $('.js-payments-nav').on('click', function(e) {
      const $this = $(this);
      const href = $this.attr('href');
      displayActiveFlatNav(href);
      if (history && history.replaceState) {
        history.replaceState({}, '', href);
      }
      $('.js-payments-nav')
        .closest('li')
        .removeClass('active');
      $this.closest('li').addClass('active');
      e.preventDefault();
    });
    $('.js-gus-tip-dismiss').on('click', function() {
      const $gusTip = $(this).closest('.js-gus-tip');
      $.cookie($gusTip.data('gus-tip-cookie'), 'dismissed', { expires: 180 });
      $gusTip.hide();
    });
    $('.currencywidget').money_field({
      symbol: $('.before_text').text(),
    });
  };

  const init = function() {
    Rover.stickyPopover('[data-toggle="sticky-popover"]', {
      container: 'body',
      placement: 'top',
    });

    // Ensure that we don't allow double click on redeeming funds Submit button
    const $redeem_button = $('.js-redeem-button');
    const $redeem_form = $('.js-redeem-form');

    $redeem_button.removeAttr('disabled');
    $redeem_form.on('submit', () => {
      $redeem_button.attr('disabled', 'disabled');

      // Fix a chrome bug: http://code.google.com/p/chromium/issues/detail?id=37402
      if ($redeem_form.attr('data-submitted') !== 'true') {
        $redeem_form.attr('data-submitted', 'true');
        return true;
      } else if ($redeem_form.attr('data-submitted') === 'true') {
        return false;
      }
    });

    // Set up payment methods table - clicking anywhere on a row selects that row, and
    // the method select for each row is disabled until that row is selected.
    setUpPaymentMethodSelectionTable('#redemption-table');

    addBindings();

    displayHashedView('#payments-earnings');
  };

  init();
});



// WEBPACK FOOTER //
// ./js/pages/payments.js